import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, input, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { TaxisService } from '../../../services/order.service';
import { TranslateModule } from '@ngx-translate/core';
import { I } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-expandable-panel',
  standalone: true,
    imports: [CommonModule,TranslateModule],
  templateUrl: './expandable-panel.component.html',
  styleUrls: ['./expandable-panel.component.scss']
})
export class ExpandablePanelComponent implements OnInit {
  @Input()
  isClient: boolean = false;

  @Input()
  expandedHeight: '30' | '50' = '50'; // Default to 50% height when expanded
  @Input()
  taxiType:number=0;




  
  constructor(private _orderService: TaxisService,
    
        @Inject(PLATFORM_ID) private platformId: Object,
    
  ) { // Replace 'any' with the actual type of _orderService
    // You can inject your order service here

  }
  async ngOnInit() {

    // let validClient = await lastValueFrom(
    //     this._orderService.checkClientToken()
    // );
    // console.log('VALID CLIENT ==> ', validClient);
    // if (validClient.success) {
    //   // this.validClient = validClient?.data ?? null;
    //   this.isClient = true;
    // }else{
    //   this.togglePanel();

    // }

    if(isPlatformBrowser(this.platformId) && !this.isClient && localStorage != undefined){
        let token = localStorage.getItem('clientToken')
        if(!token){
          // this.isExpanded=true;
        }
    }
    
  
  }
  @Input()
  isExpanded = false;
  count = 3;

  @Input()
  qtyControl: any
  @Input() luggageControl: any



  togglePanel() {
    this.isExpanded = !this.isExpanded;
    // Get the expandable panel element and change its style
    // const expandablePanelElement = document.querySelector('.expandable-panel') as HTMLElement;
    // if (expandablePanelElement) {
    //   if (this.isExpanded) {
       

    //     expandablePanelElement.style.position = 'fixed';
        
    //     expandablePanelElement.style.bottom = '124px';

    //   } else {
    //     expandablePanelElement.style.position = 'fixed';
    //     expandablePanelElement.style.top = '10px';

    //     // expandablePanelElement.style.maxHeight = '0';
    //   }
    // }
  }

  adjustNumber(delta: number) {
    this.count += delta;
  }
}
